import { defineStore } from 'pinia';

export const useAnnouncementStore = defineStore('announcement', {
  state: () => ({
    announcementHtml: null,
  }),
  // getters: {
  // },
  actions: {
    init(announcementValue) {
      if (!announcementValue) return;
      this.announcementHtml = announcementValue.announcementHtml;
    },
  },
});
